// extracted by mini-css-extract-plugin
export default {"tableManager":"TablePromoCode_tableManager__rHd93","tableContainer":"TablePromoCode_tableContainer__vZnDO","scrollBox":"TablePromoCode_scrollBox__7i98A"};